// extracted by mini-css-extract-plugin
export var container = "styles-module--container--yz-Zz";
export var item = "styles-module--item--66Zjy";
export var title = "styles-module--title--EexsN";
export var content = "styles-module--content--mL+-h";